import { render, staticRenderFns } from "./MomentItemFeedV2.vue?vue&type=template&id=96ea0696&scoped=true&"
import script from "./MomentItemFeedV2.vue?vue&type=script&lang=js&"
export * from "./MomentItemFeedV2.vue?vue&type=script&lang=js&"
import style0 from "./MomentItemFeedV2.vue?vue&type=style&index=0&id=96ea0696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ea0696",
  null
  
)

export default component.exports